/**
 * 账号绑定工具函数
 */

export interface BindUserInfo {
  bind_phone: string | null
  openid: string | null
  unionid: string | null
}

/**
 * 脱敏手机号
 */
export function maskPhone(phone?: string | null): string {
  if (!phone) {
    return '未绑定'
  }

  if (phone.length < 7) {
    return phone
  }

  return `${phone.slice(0, 3)}****${phone.slice(-4)}`
}

/**
 * 是否已绑定手机号
 */
export function isPhoneBound(userInfo?: BindUserInfo | null): boolean {
  return Boolean(userInfo?.bind_phone)
}

/**
 * 是否已绑定微信
 */
export function isWechatBound(userInfo?: BindUserInfo | null): boolean {
  return Boolean(userInfo?.openid)
}
